module.exports = __webpack_public_path__ + "static/media/ChristmasPoems.bc6cd609.jpg";